import { render, staticRenderFns } from "./WebAgentTab.vue?vue&type=template&id=22394c0a&scoped=true"
import script from "./WebAgentTab.vue?vue&type=script&lang=js"
export * from "./WebAgentTab.vue?vue&type=script&lang=js"
import style0 from "./WebAgentTab.vue?vue&type=style&index=0&id=22394c0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22394c0a",
  null
  
)

export default component.exports